import React, { useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import InputGroup from "../InputGroup/InputGroup"
import { changeWillRelocate } from "../../Redux/Actions/SpouseApplication/functions"
import { getCountries, getRegions } from "../../Utils/locationsApi"

import "./SpouseLocationInputs.css"

const initialInputs = [
  {
    id: 0,
    className: "streetAddress",
    userField: "address.streetAddress",
    inputType: "text",
    placeHolder: "Street Address",
    title: "Street Address",
    required: true,
  },
  {
    id: 1,
    className: "city",
    userField: "address.city",
    placeHolder: "City",
    inputType: "text",
    title: "City",
    required: true,
  },
  {
    id: 2,
    className: "state",
    userField: "address.state",
    placeHolder: "State",
    inputType: "select",
    options: [],
    title: "State",
    required: true,
  },
  {
    id: 3,
    className: "zipCode",
    userField: "address.zipCode",
    placeHolder: "Zip Code",
    inputType: "text",
    title: "Zip Code",
    required: true,
  },
  {
    id: 4,
    className: "country",
    userField: "address.country",
    placeHolder: "Country",
    inputType: "select",
    options: [],
    title: "Country",
    required: true,
  },
  {
    id: 5,
    className: "willLocate",
    userField: "address.willLocate",
    inputType: "select",
    placeHolder: "Are you planning to or willing to relocate? Y/N",
    title: "Are you planning to or willing to relocate?",
    className: "relocation",
    options: [
      { id: 0, value: "No" },
      { id: 1, value: "Yes" }
    ],
    required: true,
  }
]

const SpouseLocationInputs = (props) => {
  const dispatch = useDispatch()
  const application = useSelector((state) => state.spouseApplication.application)
  const [inputs, setInputs] = useState(initialInputs)

  const inputDataWithValues = inputs.map((input) => {
    let value = Object.byString(application, input.userField) || ""
    if (input.userField === "address.country") {
      value = value || "United States"
    }

    return {
      ...input,
      value
    }
  })

  const requiredValidators = (input) => ({
    ...input,
    error: !!(input.required && input.value.length === 0)
  })

  const dateOfBirthValidator = (input) => {
    if (input.textField === "dateOfBirth") {
      return {
        ...input,
        error: true
      }
    }
    return input
  }

  const updateStates = async (countryId) => {
    if (!countryId) return

    const statesInputIndex = inputs.findIndex(
      ({ userField }) => userField === "address.state"
    )

    const countryRegions = await getRegions(countryId)

    inputs[statesInputIndex] = {
      ...inputs[statesInputIndex],
      options: countryRegions
    }

    setInputs([...inputs])
  }

  const handleChange = (currentInput, value) => {
    if (!currentInput || !value) return

    switch (currentInput.userField) {
      case "address.willLocate":
        dispatch(changeWillRelocate(value === "Yes"))
        break
      case "address.country":
        const { countryId } =
          currentInput.options?.find((option) => option.value === value) || {}
        updateStates(countryId)
        break
      default:
        break
    }
  }

  useEffect(() => {
    ;(async () => {
      const countriesInputIndex = inputs.findIndex(
        ({ userField }) => userField === "address.country"
      )

      const countries = await getCountries()

      inputs[countriesInputIndex] = {
        ...inputs[countriesInputIndex],
        options: countries
      }

      const initialCountry = inputDataWithValues.find(
        ({ userField }) => userField === "address.country"
      )

      if (initialCountry.value && countries) {
        const { countryId } =
          countries?.find((option) => option.value === initialCountry.value) ||
          {}
        updateStates(countryId)
      }

      setInputs([...inputs])
    })()
  }, [])

  return (
    <InputGroup
      {...props}
      containerClass="personalInfoTwoContainer"
      inputData={inputDataWithValues}
      onInputChange={handleChange}
      renderComponent={({ inputComponent, inputData, checkSubmittability }) => {
        return (
          <>
            {props.renderComponent({
              ...props,
              inputData,
              checkSubmittability,
              inputComponent,
              validators: [requiredValidators, dateOfBirthValidator]
            })}
          </>
        )
      }}
    />
  )
}

export default SpouseLocationInputs
